import SvgIcon from '@mui/material/SvgIcon'

const FilterIcon = ({
    className,
}: Readonly<{ className?: string }>) => {
    return (
        <SvgIcon
            viewBox="0 0 17 15"
            sx={{
                width: 17,
                height: 17,
            }}
            className={className}
        >
            <path
                d="M7.99996 16C7.71662 16 7.47913 15.9042 7.28746 15.7125C7.09579 15.5208 6.99996 15.2833 6.99996 15V9L1.19996 1.6C0.949958 1.26667 0.912458 0.916667 1.08746 0.55C1.26246 0.183333 1.56662 0 1.99996 0H16C16.4333 0 16.7375 0.183333 16.9125 0.55C17.0875 0.916667 17.05 1.26667 16.8 1.6L11 9V15C11 15.2833 10.9041 15.5208 10.7125 15.7125C10.5208 15.9042 10.2833 16 9.99996 16H7.99996Z"
            />
        </SvgIcon>
    )
}

export default FilterIcon
